const initialDropdown = {
  loading: false,
  value: "",
  options: [],
  error: false
};
const dropdownReducer = (state, action) => {
  if (action.type === "LOADING") {
    return {
      ...initialDropdown,
      loading: true
    };
  }
  if (action.type === "SET_OPTIONS") {
    return {
      ...initialDropdown,
      options: action.payload
    };
  }
  if (action.type === "SET_VALUE") {
    return {
      ...state,
      value: action.payload
    };
  }
  if (action.type === "ERROR") {
    return {
      ...initialDropdown,
      error: true
    };
  }
  if (action.type === "RESET") {
    return initialDropdown;
  }
  return state;
};

export { dropdownReducer, initialDropdown };
